/**
 * A list of values (ids, or free text such as a legacy department name "R&D, Pune")
 * packed into one URL value. Each item is percent-encoded before joining, so a comma inside
 * a name cannot split it. Pure; used by `useUrlState` callers.
 */

export const encodeUrlList = (items: readonly string[]): string =>
  items.map((v) => encodeURIComponent(v)).join(',');

export const decodeUrlList = (raw: string): string[] =>
  raw
    .split(',')
    .filter(Boolean)
    .map((v) => {
      try {
        return decodeURIComponent(v);
      } catch {
        return ''; // a hand-edited, malformed escape: drop the item, never throw
      }
    })
    .filter(Boolean);
